import { Button, Modal } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { savePoster } from "../../../store/poster/thunks";

const ClonePoster = ({ poster_id }) => {
  const dispatch = useDispatch();

  const handleClonePoster = useCallback(() => {
    Modal.confirm({
      title: "Clone Poster",
      content: "Are you sure you want to clone this poster?",
      okText: "Yes, Clone",
      okType: "primary",
      onOk: async () => {
        try {
          const result = await dispatch(
            savePoster({
              poster_id,
              isClone: true,
            }),
          );

          return result;
        } catch (error) {
          console.error("🚀 ~ handleClonePoster ~ error:", error);
          throw error;
        }
      },
      onCancel: () => {
        console.log("Poster cloning cancelled");
      },
    });
  }, [poster_id, dispatch]);

  return (
    <Button
      onClick={handleClonePoster}
      icon={<CopyOutlined />}
      color="primary"
      variant="dashed"
    />
  );
};

export default ClonePoster;
